import { useEffect, useState } from "react";
import { promptForInstall, subscribeToInstallPrompt } from "../core/pwa-install";

export function usePWAInstall() {
  const [isInstallable, setIsInstallable] = useState(false);

  useEffect(() => subscribeToInstallPrompt(setIsInstallable), []);

  return {
    isInstallable,
    promptInstall: promptForInstall
  };
}
